import React from 'react';
import PropTypes from 'prop-types';
import Field from 'redux-form/es/Field';
import { FormattedMessage } from 'react-intl';
import InputSelectField from 'components/Credit24/Core/Controls/InputSelectField';
import InputField from 'components/Credit24/Core/Controls/InputField';
import InputToggleField from 'components/Credit24/Core/Controls/InputToggleField';
import { useTranslationSuffix } from 'hooks/useTranslationSuffix';

const propTypes = {
  educationTypes: PropTypes.array.isRequired,
  workingStateTypes: PropTypes.array.isRequired,
  employmentDurationTypes: PropTypes.array.isRequired,
  areDetailsNeeded: PropTypes.bool,
  hasSecondJob: PropTypes.bool,
  companyNameTitle: PropTypes.string,
  employmentDurationTitle: PropTypes.string,
};

const EducationWorkDetailsAU = (props) => {
  const translationKeys = {
    title: 'education_work.title',
    secondJobTitle: 'second_job.title',
  };
  const translations = useTranslationSuffix('upgrade', translationKeys);

  return (
    <div className="loan-form__step">
      <h1 className="loan-form__step-title">
        <FormattedMessage id={translations.title} />
      </h1>
      <div className="loan-form__step-body">
        <Field
          name="education"
          component={InputSelectField}
          options={props.educationTypes}
          emptyTextKey="education_type.title"
          isFullWidth
        />
        <Field
          name="occupation"
          component={InputSelectField}
          options={props.workingStateTypes}
          emptyTextKey="occupation_type.title"
          isFullWidth
        />
        {props.areDetailsNeeded
          && (
            <div className="grid">
              <div className="grid__item one-half palm-one-whole">
                <Field
                  title={<FormattedMessage id={props.companyNameTitle || 'company_name.title'} />}
                  name="company"
                  type="text"
                  component={InputField}
                  isFullWidth
                />
              </div>
              <div className="grid__item one-half palm-one-whole">
                <Field
                  name="employmentDuration"
                  component={InputSelectField}
                  options={props.employmentDurationTypes}
                  emptyTextKey={props.employmentDurationTitle || 'employment_duration.title'}
                  isFullWidth
                />
              </div>
              <div className="grid__item one-whole">
                <Field
                  title={<FormattedMessage id="job_title.title" />}
                  name="jobTitle"
                  component={InputField}
                  isFullWidth
                />
              </div>
              <div className="grid__item one-half palm-one-whole">
                <Field
                  title={<FormattedMessage id={translations.secondJobTitle} />}
                  name="secondJob"
                  component={InputToggleField}
                />
              </div>
              {props.hasSecondJob && (
                <div className="grid__item one-half palm-one-whole">
                  <Field
                    title={<FormattedMessage id="second_company_name.title" />}
                    name="secondCompany"
                    type="text"
                    component={InputField}
                    isFullWidth
                  />
                </div>
              )}
            </div>
          )}
      </div>
    </div>
  );
};

EducationWorkDetailsAU.propTypes = propTypes;

export default EducationWorkDetailsAU;
